import axios from "axios";
import { config } from "./config";

const dataServiceUrl = `${config.dataServiceUrl}`;
const interfaceServiceUrl = `${config.interfaceServiceUrl}`;

// const https = require("https");
// const agent = new https.Agent({
//     rejectUnauthorized: false,
//     requestCert: false,
//     agent: false
// });

// const apiClient = axios.create({
//     responseType: "json",
//     withCredentials: false,
//     httpsAgent: agent
// });


export function getHeader(token) {
    return {
        "Authorization": "Bearer " + token,
        "Content-Type": "application/json"
    };
};

// esb-data answers a refused sign-in with 200 and the reason in the body, not an error
// status - so this wraps that reason as an Error the onFail handlers can treat like any
// other failure. Flagged, because the message was written for a person to read and should
// be shown as-is rather than replaced with something generic.
export function serviceError(message) {
    const error = new Error(message);
    error.isServiceError = true;
    return error;
}

export function handleErrors(error, onError) {
    if (Object.keys(error).length > 0 && error.response?.status === 401) {
        window.location.replace("/signout");
    }
    else {
        let errorMsg = error.message;
        console.log(errorMsg);
        if (errorMsg.toLowerCase().includes('connection') || errorMsg.toLowerCase().includes('unexpected') || errorMsg.toLowerCase().includes('sql') || errorMsg.toLowerCase().includes('jdbc')) {
            error.message = 'Unable to connect to the ESB services. Please contact your network administrator.';
        }

        onError(error);
    }
};

export function getMessages(token, page, rows, sort, desc, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/messages?page=" + page + "&pageRows=" + rows + "&sortOn=" + sort + "&desc=" + desc, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getTopics(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/message/topics", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getFilteredMessages(token, filter, page, rows, sort, desc, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/filtered-messages?page=" + page + "&pageRows=" + rows + "&sortOn=" + sort + "&desc=" + desc, filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getToken(settings, onSuccess, onFail) {
    const headers = {
        "username": settings.userName,
        "password": settings.password,
        "Content-Type": "application/json"
    };

    axios.post(dataServiceUrl + "/api/v1/auth/login", null, {
        headers: headers
    }).then((response) => {
        if (response.data.error) {
            onFail(serviceError(response.data.errors[0]));
        }
        else {
            onSuccess(response);
        }
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

// Bridges an already-authenticated RBAC session into esb-data's own token scheme — esb-data
// verifies the RBAC token itself (signature/issuer/expiry) rather than trusting a client-
// supplied username/blank password. Same response shape as getToken() above.
export function getTokenViaRbac(rbacToken, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/auth/rbac-exchange", null, {
        headers: getHeader(rbacToken)
    }).then((response) => {
        if (response.data.error) {
            onFail(serviceError(response.data.errors[0]));
        }
        else {
            onSuccess(response);
        }
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function replayMessage(token, messageId, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/message/replay/" + messageId, "{}", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        onFail(error);
    });
};

export  function getIntegrations(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/integrations", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function postIntegrations(token, body, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/integrations", body, {
        headers: getHeader(token)
    }).then(() => {
        onSuccess()
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getIntegrationStatus(token, onSuccess, onFail) {
    axios.get(interfaceServiceUrl + "/api/v1/integrations/status", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};


export function startIntegration(token, id, onSuccess, onFail) {
    axios.post(interfaceServiceUrl + "/api/v1/integrations/start/" + id, {}, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function stopIntegration(token, id, onSuccess, onFail) {
    axios.post(interfaceServiceUrl + "/api/v1/integrations/stop/" + id, {}, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function restartIntegration(token, id, onSuccess, onFail) {
    axios.post(interfaceServiceUrl + "/api/v1/integrations/restart/" + id, {}, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};


export function deleteIntegration(token, row, onSuccess, onFail) {
    axios.delete(dataServiceUrl + "/api/v1/data/integrations", {
        headers: getHeader(token),
        data: JSON.stringify(row),
    }).then(() => {
        onSuccess();
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getAppLog(token, refId, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/log/" + refId, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function getAppLogs(token, refs, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/log/alarm", refs, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function getSettingCategories(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/settings/categories", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function getSettings(token, category, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/settings/" + category, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function saveSettings(token, username, data, onSuccess, onFail) {
    let header = getHeader(token);
    header.username = username;

    axios.post(dataServiceUrl + "/api/v1/data/settings", data, {
        headers: header
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getUsers(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/users", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function saveUser(token, user, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/user", user, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function deleteUser(token, userId, onSuccess, onFail) {
    axios.delete(dataServiceUrl + "/api/v1/data/users/" + userId, {
        headers: getHeader(token)
    }).then(() => {
        onSuccess();
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getMessageSources(token, page, rows, sort, desc, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/message-sources?page=" + page + "&pageRows=" + rows + "&sortOn=" + sort + "&desc=" + desc, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function saveMessageSource(token, source, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/message-sources", source, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function deleteMessageSource(token, sourceId, onSuccess, onFail) {
    axios.delete(dataServiceUrl + "/api/v1/data/message-sources/" + sourceId, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

// The full, unpaged source list - what a filter dropdown needs. getMessageSources below is
// paged and sorted for the maintenance grid, which is a different job.
export function getSources(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/sources", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function getAlarmPriorities(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/alarm/priorities", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function saveAlarmPriority(token, priority, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/alarm/priorities", priority, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function deleteAlarmPriority(token, priority, onSuccess, onFail) {
    axios.delete(dataServiceUrl + "/api/v1/data/alarm/priorities", {
        headers: getHeader(token),
        data: JSON.stringify(priority),
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getAlarmTypes(token, filter, page, rows, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/alarm/filtered-types?page=" + page + "&pageRows=" + rows, filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getAlarmTypeGroup(token, filter, groupId, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/alarm-group/" + groupId, filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function saveAlarmTypeGroup(token, groups, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/alarm-type-group", groups, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};


export function saveAlarmTypes(token, types, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/alarm/types", types, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function deleteAlarmTypes(token, types, onSuccess, onFail) {
    axios.delete(dataServiceUrl + "/api/v1/data/alarm/types", {
        headers: getHeader(token),
        data: JSON.stringify(types),
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function importAlarmFile(token, data, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/alarm-types/upload", data, {
        headers: {"Authorization": "Bearer " + token}
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function getSourceFields(token, sourceId, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/source-fields/" + sourceId, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getActiveAlarms(token, page, rows, sort, desc, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/active-alarms?page=" + page + "&pageRows=" + rows + "&sortOn=" + sort + "&desc=" + desc, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getFilteredAlarms(token, filter, page, rows, sort, desc, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/filtered-alarms?page=" + page + "&pageRows=" + rows + "&sortOn=" + sort + "&desc=" + desc, filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getAlarmTotals(token, filter, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/alarm-totals", filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getDictionary(token, filter, page, rows, sort, desc, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/dictionary?page=" + page + "&pageRows=" + rows + "&sortOn=" + sort + "&desc=" + desc, filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getDictionaryCategories(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/dictionary/categories", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function saveDictionaryItems(token, items, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/dictionary/items", items, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function deleteDictionaryItem(token, item, onSuccess, onFail) {
    axios.delete(dataServiceUrl + "/api/v1/data/dictionary/items", {
        headers: getHeader(token),
        data: item
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getAlarmGroups(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/alarm-groups", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function saveAlarmGroup(token, group, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/alarm-groups", group, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function deleteAlarmGroup(token, group, onSuccess, onFail) {
    axios.delete(dataServiceUrl + "/api/v1/data/alarm-groups", {
        headers: getHeader(token),
        data: group
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getMessageDayTotal(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/stats/messages/day", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getTopicTotals(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/stats/topic/count", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function clearAlarm(token, alarmId, userId, onSuccess, onFail) {
    axios.put(dataServiceUrl + "/api/v1/alarm/clear?alarmId=" + alarmId + "&user=" + userId, null, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function clearAllAlarms(token, filter, isAlarm, userId, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/alarm/clear-all?alarms=" + isAlarm + "&user=" + userId, filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};


export function importLocationFile(token, data, overwrite, userName, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/lookup/upload?overwrite=" + overwrite + "&username=" + userName, data, {
        headers: {"Authorization": "Bearer " + token}
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail)
    });
};

export function getFilteredLocations(token, filter, page, rows, sort, desc, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/lookup/filtered-locations?page=" + page + "&pageRows=" + rows + "&sortOn=" + sort + "&desc=" + desc, filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function saveLocation(token, location, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/lookup/save-location", location, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};


export function deleteLocation(token, location, onSuccess, onFail) {
    axios.delete(dataServiceUrl + "/api/v1/lookup/delete-location", {
        headers: getHeader(token),
        data: JSON.stringify(location),
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getLogTypes(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/log/types", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getFilteredLogs(token, filter, page, rows, sort, desc, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/data/filtered-logs?page=" + page + "&pageRows=" + rows + "&sortOn=" + sort + "&desc=" + desc, filter, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function getSystemServices(token, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/system/services", {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function restartService(token, id, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/system/services/restart/" + id, {}, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function startService(token, id, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/system/services/start/" + id, {}, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

export function stopService(token, id, onSuccess, onFail) {
    axios.post(dataServiceUrl + "/api/v1/system/services/stop/" + id, {}, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response)
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};

// Sensor/occupancy totals for the GHD dashboard variant (REACT_APP_DASHBOARD=ghd).
// esb-data's SensorController serves this; it arrived on trunk with the nsp lineage.
export function getScheduleTotals(token, date, type, fixed, force, onSuccess, onFail) {
    axios.get(dataServiceUrl + "/api/v1/data/sensors/schedule?date=" + date + "&type=" + type + "&fixed=" + fixed + "&force=" + force, {
        headers: getHeader(token)
    }).then((response) => {
        onSuccess(response);
    }).catch((error) => {
        handleErrors(error, onFail);
    });
};
